(function($){
    /**
     * Short list applicant
     */
    // $('.btn-shortlist-applicant').on( 'click', function(e){
     $(document).on('click', '.btn-shortlist-applicant', function(e){
        e.preventDefault();
        const $this = $(this);
        const data = {
            'action'      : 'shortlist_applicant',
            'nonce'       : ajax_callback_data.ajax_nonce,
            'applicantId' : $this.data('applicant'),
            'jobId'       : $this.data('job'),
            'type'        : $this.data('type'),
            'userId'      : $this.data('user'),
            'match'       : $this.data('match')
        }

        $.ajax({
           type : "POST",
           data : data,
           url  : ajax_callback_data.ajax_url,
           success: function(response){
                $('.card-list.card--applicants-list.shortlisted').append(response.data);

                // remove the shortlisted from applicants list now
                $this.closest('.card-list-item').remove();
           }
        });

    });

    /*
    * Remove applicant from shortlist
    */
    // $('.btn-shortlist-applicant-remove').on( 'click', function(e){
    $(document).on('click', '.btn-shortlist-applicant-remove', function(e){
        e.preventDefault();
        const $this = $(this);
        const data = {
            'action'      : 'shortlist_applicant_remove',
            'nonce'       : ajax_callback_data.ajax_nonce,
            'applicantId' : $this.data('applicant'),
            'jobId'       : $this.data('job'),
            'type'        : $this.data('type'),
            'userId'      : $this.data('user'),
            'match'       : $this.data('match')
        }

        $.ajax({
            type : "POST",
            data : data,
            url  : ajax_callback_data.ajax_url,
            success: function(response){
                $('.card-list.card--applicants-list.all').append(response.data);

                // remove the applicant from shortlist now
                $this.closest('.card-list-item').remove();
            }
        });
    });

})(jQuery);